export const commaFormat = (number, digitCount = 1) => {
  const tenPower = 10 ** digitCount;
  const parts = (Math.round(number * tenPower) / tenPower).toString().split('.');
  parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};
export const floatFromCommaFormat = number => {
  return parseFloat(number.split(',').join(''));
};
